import { render, staticRenderFns } from "./PostV2.vue?vue&type=template&id=0bc02b4d&"
import script from "./PostV2.vue?vue&type=script&lang=js&"
export * from "./PostV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jlamb/repos/roll20/d20app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc02b4d')) {
      api.createRecord('0bc02b4d', component.options)
    } else {
      api.reload('0bc02b4d', component.options)
    }
    module.hot.accept("./PostV2.vue?vue&type=template&id=0bc02b4d&", function () {
      api.rerender('0bc02b4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/blog-preview/src/components/Posts/PostV2.vue"
export default component.exports